import { PayoutAccountState } from 'modules/host-payout-methods/context/PayoutFormContext';
import { PayoutAccount } from 'modules/host-payout-methods/models/PayoutAccount';

const appendOrReplace = (current, fresh) => [
  ...current.map(
    (item) => fresh.find((newItem) => newItem.id === item.id) || item,
  ),
  ...fresh.filter((newItem) => !current.some((item) => item.id === newItem.id)),
];

const sortPreferredFirst = (payoutAccounts: PayoutAccount[]) => {
  return payoutAccounts.sort((a) => (a.isPreferred ? -1 : 1));
};

export default function (
  state: PayoutAccountState,
  action,
): PayoutAccountState {
  switch (action.type) {
    case 'SUBMIT:SUCCESS':
      if (action.payoutAccount.id) {
        return {
          ...state,
          data: sortPreferredFirst(
            appendOrReplace(
              state.data.map((payoutAccount) => ({
                ...payoutAccount,
                isPreferred: false,
              })),
              [
                {
                  ...action.payoutAccount,
                },
              ],
            ),
          ),
        };
      }
      return state;
    case 'DELETE_PAYOUT_ACCOUNT':
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case 'DELETE_PAYOUT_ACCOUNT:SUCCESS':
      return {
        ...state,
        data: sortPreferredFirst([
          ...state.data.filter((f) => f.id !== action.id),
        ]),
        loading: false,
        error: undefined,
      };
    case 'DELETE_PAYOUT_ACCOUNT:ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case 'FETCH_PAYOUT_ACCOUNTS':
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case 'FETCH_PAYOUT_ACCOUNTS:SUCCESS':
      return {
        ...state,
        data: sortPreferredFirst(
          appendOrReplace(state.data, action.payoutAccounts),
        ),
        loading: false,
        error: undefined,
      };
    case 'FETCH_PAYOUT_ACCOUNTS:ERROR':
      return {
        ...state,
        loading: false,
        error: action.error,
      };
  }
  return state;
}
